<template>
  <div class="wrapper">
    <div class="box">
      <div class="item">
        <div class="itemLeft">
          <img style="width: .5rem;height: .5rem;" src="../../assets/images/fingerpost/fingerpost_buy.png" alt="">
          <span>购买流程</span>
        </div>
        <div class="itemRight">
          <p class="itemText" @click="toDetail('buy','1')">如何购买商品？</p>
          <p class="itemText" @click="toDetail('buy','2')">如何购买购物车？</p>
          <p class="itemText" @click="toDetail('buy','3')">支持那些支付方式？</p>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">
          <img src="../../assets/images/fingerpost/fingerpost_goods.png" alt="">
          <span>商品</span>
        </div>
        <div class="itemRight">
          <p class="itemText" @click="toDetail('goods','1')">有米日记的商品从哪里发货？</p>
          <p class="itemText" @click="toDetail('goods','2')">有米日记的发货时间在哪里查看？</p>
          <p class="itemText" @click="toDetail('goods','3')">购买的商品是否正品？</p>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">
          <img src="../../assets/images/fingerpost/fingerpost_order.png" alt="">
          <span>订单</span>
        </div>
        <div class="itemRight">
          <p class="itemText" @click="toDetail('order','1')">如何取消订单？</p>
          <p class="itemText" @click="toDetail('order','2')">我的订单怎么还没发货？</p>
          <p class="itemText" @click="toDetail('order','3')">如何修改订单收件信息？</p>
          <p class="itemText" @click="toDetail('order','4')">同一个订单中的多个商品是同一个包裹发货吗？</p>
          <p class="itemText" @click="toDetail('order','5')">订单信息填写错误或拍错规格怎么处理？</p>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">
          <img src="../../assets/images/fingerpost/fingerpost_express.png" alt="">
          <span>物流配送</span>
        </div>
        <div class="itemRight">
          <p class="itemText" @click="toDetail('express','1')">有米日记的商品包邮了吗？</p>
          <p class="itemText" @click="toDetail('express','2')">购买的商品发货了吗？</p>
          <p class="itemText" @click="toDetail('express','3')">如何查看包裹物流信息？</p>
          <p class="itemText" @click="toDetail('express','4')">物流信息怎么不更新了？</p>
          <p class="itemText" @click="toDetail('express','5')">没有收到包裹，怎么显示签收了？</p>
          <p class="itemText" @click="toDetail('express','6')">包裹漏发了怎么办？</p>
          <p class="itemText" @click="toDetail('express','7')">同一订单购买多个不同的商品(混合订单)时如何分别查询物流情况？</p>
          <p class="itemText" @click="toDetail('express','8')">包裹怎么显示被退回了？</p>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">
          <img style="width: .7rem;height: .7rem;" src="../../assets/images/fingerpost/fingerpost_refund.png" alt="">
          <span>售后</span>
        </div>
        <div class="itemRight">
          <p class="itemText" @click="toDetail('refund','1')">*售后必读</p>
          <p class="itemText" @click="toDetail('refund','2')">如何办理退换货手续？</p>
          <p class="itemText" @click="toDetail('refund','3')">水果生鲜食品类收到有损坏如何售后？</p>
          <p class="itemText" @click="toDetail('refund','4')">服饰百货类收到有破损如何售后？</p>
          <p class="itemText" @click="toDetail('refund','5')">如何申请售后？</p>
          <p class="itemText" @click="toDetail('refund','6')">收到的包裹漏发了怎么办？</p>
          <p class="itemText" @click="toDetail('refund','7')">如何撤销售后申请？</p>
          <p class="itemText" @click="toDetail('refund','8')">退款到账时间是多久？</p>
          <p class="itemText" @click="toDetail('refund','9')">关于拦截快递问题</p>
          <p class="itemText" @click="toDetail('refund','10')">关于客服服务问题产生投诉</p>
        </div>
      </div>
      <div class="item">
        <div class="itemLeft">
          <img style="width: .5rem;height: .5rem;" src="../../assets/images/fingerpost/fingerpost_coupon.png" alt="">
          <span>优惠券</span>
        </div>
        <div class="itemRight" style="min-height: 2.19rem;padding-top: .45rem;box-sizing: border-box;">
          <p class="itemText" @click="toDetail('coupon','1')">在哪里查看到我的优惠券？</p>
          <p class="itemText" @click="toDetail('coupon','2')">如何使用我的优惠券？</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
    };
  },
  watch: {},
  methods: {
    toDetail(type,num){
      this.$router.push({path:'/fingerpostDetail',query:{type:type,num:num}});
    },
    initPage(){
      let option = {
          title: '有米@'+this.userInfo.name + "的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
    }
  },
  created() {
    document.title = "新手指南";
    this.initPage()
  },
  mounted() {
  }
};
</script>
<style scoped lang='less'>
.wrapper{
  background:#ededed;
  padding:.2rem 0;
  display:flex;
  flex-direction: column;
  align-items: center;
}
.box{
  width:7.1rem;
  background:#fff;
  border-radius: 0.2rem;
  box-sizing: border-box;
  padding-bottom: .36rem;
}
.item{
  width:7.1rem;
  padding: .22rem 0;
  border-bottom: 1px solid #979797;
  display: flex;
  flex-direction: row;
  align-items: center;
  .itemLeft{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 0 0 2.44rem;
    width: 2.44rem;
    img{
      width: .6rem;
      height: .6rem;
      margin-bottom: .18rem;
    }
    span{
      font-size: .3rem;
      color: #101010;
      line-height: .42rem;
    }
  }
  .itemRight{
    flex:1;
    border-left: 1px solid #979797;
    box-sizing: border-box;
    padding: 0 .2rem;
    .itemText{
      font-size: .28rem;
      color: #101010;
      line-height: .4rem;
      margin-bottom: .5rem;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/fingerpost.vue